<template>
    <svg xmlns="http://www.w3.org/2000/svg"
        :width="width"
        :height="height"
        viewBox="0 0 19.608 20.801"
        aria-labelledby="good_job"
        role="presentation">

    <title>good_job</title>
    <g :fill="iconColor">
        <g id="layer_2" data-name="layer 2">
            <g id="layer_1-2" data-name="layer 1">
                <path class="cls-1" d="M19.17,9.247l-.435-.283a.961.961,0,0,0-1.33.282l-.569.875V3.071a.962.962,0,1,0-1.923,0v4.18h-.422V2.639a.962.962,0,0,0-.962-.961h-.2a.961.961,0,0,0-.961.961V7.251h-.422V3.086a.962.962,0,0,0-.962-.962h-.2a.962.962,0,0,0-.961.962v3.2a1.453,1.453,0,0,1,.293.33L13.051,11.3a1.47,1.47,0,0,1,.349-.523,1.4,1.4,0,0,1,1.039-.41l.521.009A1.462,1.462,0,0,1,16.4,11.866l-.047,2.746h.488V14.6l2.617-4.027A.962.962,0,0,0,19.17,9.247Z"/>
                <path class="cls-1" d="M8.106,6.152a1.456,1.456,0,0,1,1.3-.119V3.986a.962.962,0,0,0-.962-.962H8.322a.962.962,0,0,0-.962.962V7c.034.018.071.027.1.048A1.457,1.457,0,0,1,8.106,6.152Z"/><rect class="cls-1" x="2.125" y="1.267" width="1.214" height="2.509" transform="translate(-0.842 1.499) rotate(-26.739)"/><rect class="cls-1" x="0.783" y="3.71" width="1.214" height="2.509" transform="translate(-3.604 3.686) rotate(-60)"/><rect class="cls-1" x="4.447" width="1.214" height="2.509"/>
                <path class="cls-1" d="M14.881,10.788l-.519-.009a.962.962,0,0,0-.978.945l-.018,1.044L9.627,6.791A.961.961,0,1,0,8,7.81l2.217,3.545-.358.223L7.41,7.669a.962.962,0,0,0-1.325-.306l-.168.1a.961.961,0,0,0-.3,1.325L8.058,12.7l-.358.224L5.491,9.4A.962.962,0,0,0,4.166,9.09L4,9.2a.962.962,0,0,0-.305,1.326L5.9,14.052l-.358.224L3.812,11.507a.962.962,0,0,0-1.325-.3l-.1.065a.961.961,0,0,0-.306,1.325l4.374,6.991a.7.7,0,0,0,.319.273l2.221.945,6.755-4.226,0-.007.083-4.8A.962.962,0,0,0,14.881,10.788Z"/>
            </g>
        </g>
    </g>
    </svg>
</template>

<script>

export default {
  props: {
    width: {
      type: Number,
      default: 18
    },
    height: {
      type: Number,
      default: 18
    },
    iconColor: {
      type: String,
      default: 'gray'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/icon/GoodJob.vue